import './index.css';
import img from '../../../src/images/Filter.svg';
import img1 from '../../../src/images/Ai.svg';
import img2 from '../../../src/images/Profile.svg';
import img3 from '../../../src/images/Avatar.svg';
import img4 from '../../../src/images/Icon (1).svg';
import img5 from '../../../src/images/Alerts.svg';
import img6 from '../../../src/images/analysis.svg'; // Analysis Icon
import img7 from '../../../src/images/appointments.svg'; // Appointments Icon
import img8 from '../../../src/images/Icon (4).svg';
import img9 from '../../../src/images/Icon (5).svg';
import img10 from '../../../src/images/notification.svg';
import img11 from '../../../src/images/Calendar.svg';
import img13 from '../../../src/images/patient.svg'; // Patients Icon
import img14 from '../../../src/images/patient-icon.svg'; // Patients Icon

import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import config from '../../config/config';
import { useLocation } from 'react-router-dom';


// Reusable Card component
const Card = ({ title, icon, value, reports, pending, recent, details, onClick }) => {

    return (
        <div className="cards_wrapper" onClick={onClick}>
            <div className="card_icon">
                <img src={icon} alt={`${title} Icon`} />
            </div>
            <h2>{title}<br /><span>{value}</span></h2>
            <div className="bottom_line"></div>
            <div className="card_wrapper_bottom">
                {reports && (
                    <div className="pending_text">
                        <h5>Reports</h5>
                        <h6>{reports}</h6>
                    </div>
                )}
                {pending && (
                    <div className="confirmed_text">
                        <h5>Pending</h5>
                        <h6>{pending}</h6>
                    </div>
                )}
                {recent && (
                    <div className="pending_text">
                        <h5>Recent activity</h5>
                        <h6>{recent}</h6>
                    </div>
                )}

            </div>
        </div>
    );
};

function DashboardPage() {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const userName = params.get("name") || "User"; // Default to "User" if no name is passed

    const navigate = useNavigate();
    const [cards, setCards] = useState([]);
    const backendURL = `${config.backendServerHost}`;

useEffect(() => {
    // Fetch data for cards
    fetch(`${backendURL}/patients/api/cards`) // Use backticks for template literals
        .then((res) => {
            if (!res.ok) {
                throw new Error('Failed to fetch cards');
            }
            return res.json();
        })
        .then((data) =>
            setCards(
                data.map((card) => ({
                    ...card,
                    icon: getCardIcon(card.title), // Assign icon dynamically based on title
                    onClick: getCardNavigation(card.title), // Assign navigation dynamically
                }))
            )
        )
        .catch((error) => {
            console.error('Error fetching cards:', error);
        });
}, [backendURL]);

    const getCardIcon = (title) => {
        switch (title) {
            case 'Analysis & Reports':
                return img6; // Analysis Icon
            case 'Appointments':
                return img7; // Appointments Icon
            case 'Patients':
                return img13; // Patients Icon
            default:
                return img5; // Default Icon (Alerts)
        }
    };


    const getCardNavigation = (title) => {
        switch (title) {
            case 'Analysis & Reports':
                return () => navigate('/analysis'); // Navigate to AnalysisPage
            case 'Appointments':
                return () => navigate('/appointments'); // Navigate to AppointmentsPage
            case 'Patients':
                return () => navigate('/alerts'); // Navigate to AlertsPage
            default:
                return () => {}; // No action for default
        }
    };

    const handleLogout = () => {
        localStorage.removeItem("token");
        alert("Logged out successfully!");
        navigate("/login");
    };

    return (
        <div className="dashboard_container">

            <div className="navbar_container">
                <div>
                    <h1>Dashboard</h1>
                </div>
                <div className="navbar_icon">
                    <div className="navbar_icon_img">
                        <img src={img} alt="" />
                    </div>
                    <div className="navbar_icon_img">
                        <img src={img1} alt="" />
                    </div>
                    <div style={{ cursor: "pointer" }}>
                        <img src={img2} alt="" />
                    </div>
                 <button onClick={handleLogout} className="logout-button">Logout</button>

                </div>
            </div>
            <div className="navbar_bottom_line"></div>
            <div className="profile_container">
                <div className="profile_image">
                    <img src={img3} alt="" />
                </div>
                <div className="profile_heading">
                    <div>
                        <h3>{userName}</h3>
                    </div>
                    <div>
                        <h5>Endocrinologist, CA</h5>
                    </div>
                </div>
            </div>
            <div className="stats_container">
                <div className="stats_heading">
                    <div>
                        <h4>Today's Statistics</h4>
                    </div>
                    <div>
                        <h6>Tue 17 Nov, 10:00 AM</h6>
                    </div>
                </div>
                <div className="stats_button">
                    <button>
                        Today<span><img src={img4} alt="" /></span>
                    </button>
                </div>
            </div>
            <div className="bg_container">
                <div className="alerts_image">
                    <img src={img5} alt="" />
                </div>
                <div className="cards_slider">
                    <div className="cards_container">
                        {cards.map((card, index) => (
                            <Card
                                key={index}
                                title={card.title}
                                icon={card.icon}
                                value={card.value}
                                reports={card.reports}
                                pending={card.pending}
                                recent={card.recent}
                                details={card.details}
                                onClick={card.onClick} // Attach click event handler
                            />
                        ))}
                    </div>
                </div>
            </div>
            <div className="footer_container_wrapper">
                <div className="footer_container">
                    <div className="footer_icon" onClick={() => navigate('/dashboard')}>
                        <img src={img8} alt="Home Icon" />
                    </div>
                    <div className="footer_icon" onClick={() => navigate('/analysis')}>
                        <img src={img9} alt="Analytics Icon" />
                    </div>
                    <div className="footer_icon" onClick={() => navigate('/alerts')}>
                        <img src={img10} alt="Notification Icon" />
                    </div>
                    <div className="footer_icon" onClick={() => navigate('/appointments')}>
                        <img src={img11} alt="Calendar Icon" />
                    </div>
                    <div className="footer_icon" onClick={() => navigate('/Aianalysis1')}>
                        <img src={img14} alt="Patient Icon" />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DashboardPage;
